module.exports = __webpack_public_path__ + "fonts/brelaregular.c95a7fa.woff";